// import React, { useState, useEffect } from 'react';
// import ImageSelection from './ImageSelection';
// import Translation from './Translation';
// import SentenceFormation from './SentenceFormation';
// import CompletionScreen from './CompletionScreen';
// import MatchingPairs from './MatchingPairs';
// import axios from 'axios';

// const LearningFlow = () => {
//     const [currentWordIndex, setCurrentWordIndex] = useState(0);
//     const [currentStep, setCurrentStep] = useState(0);
//     const [points, setPoints] = useState(0);
//     const [rounds, setRounds] = useState([]);
//     const [currentRoundWords, setCurrentRoundWords] = useState([]);
//     const [translations, setTranslations] = useState({});

//     useEffect(() => {
//         if (rounds.length === 0) {
//             generateNewRound();
//         } else {
//             setCurrentRoundWords(rounds[rounds.length - 1]);
//         }
//     }, [rounds]);


//   useEffect(() => {
//     if (currentRoundWords.length > 0) {
//       fetchTranslationsForWords(currentRoundWords);
//     }
//   }, [currentRoundWords]);

//     const generateNewRound = async () => {
//         const learnedWords = rounds.flat(); // All words learned so far
//         const newWords = await fetchNewWordsFromGPT(learnedWords); // Fetch new words from GPT
//         setRounds([...rounds, newWords]); // Add the new round of words
//         setCurrentRoundWords(newWords); // Update the current round words
//         setCurrentWordIndex(0); // Reset to the first word of the new round
//         setCurrentStep(0); // Reset to the first step of the learning flow
//     };

//     const fetchNewWordsFromGPT = async (learnedWords) => {
//         const apiKey = 'sk-proj-R8ckuOJvBGOO7ZOFsF2kT3BlbkFJ2RtkJrlmX1tXU7OFyBAD';
//         const url = 'https://api.openai.com/v1/chat/completions';

//         const learnedWordsString = learnedWords.join(', ');
//         console.log(learnedWordsString);
        

//         try {
//             const response = await axios.post(
//                 url,
//                 {
//                     model: 'gpt-3.5-turbo',
//                     messages: [
//                         { role: 'system', content: 'You are a language assistant.' },
//                         {
//                             role: 'user',
//                             content: `I have already learned the following words: ${learnedWordsString}. Please give me five new simple words for learning. do not talk too much`,
//                         },
//                     ],
//                     max_tokens: 50,
//                     n: 1,
//                     stop: null,
//                     temperature: 0.7,
//                 },
//                 {
//                     headers: {
//                         'Authorization': `Bearer ${apiKey}`,
//                         'Content-Type': 'application/json',
//                     },
//                 }
//             );

//             // const words = response.data.choices[0].message.content.trim().split(',').map(word => word.trim());
//             const words = response.data.choices[0].message.content.match(/\d+\.\s*(\w+)/g).map(item => item.split('. ')[1]);
//             return words;
//         } catch (error) {
//             console.error('Error fetching words from GPT:', error.response ? error.response.data : error.message);
//             return ['apple', 'banana', 'cat', 'dog', 'elephant']; // Default words if API call fails
//         }
//     };


//     const fetchTranslationsForWords = async (words) => {
//         const apiKey = 'sk-proj-R8ckuOJvBGOO7ZOFsF2kT3BlbkFJ2RtkJrlmX1tXU7OFyBAD';
//         const url = 'https://api.openai.com/v1/chat/completions';

//         try {
//             const translationsObj = {};

//             for (const word of words) {
//                 const response = await axios.post(
//                     url,
//                     {
//                         model: 'gpt-3.5-turbo',
//                         messages: [
//                             { role: 'system', content: 'You are a language assistant.' },
//                             {
//                                 role: 'user',
//                                 content: `Translate the word "${word}" to Arabic. Please provide only the single Arabic word without any additional text, explanations, or punctuation.`                            },
//                         ],
//                         max_tokens: 50,
//                         n: 1,
//                         stop: null,
//                         temperature: 0.7,
//                     },
//                     {
//                         headers: {
//                             'Authorization': `Bearer ${apiKey}`,
//                             'Content-Type': 'application/json',
//                         },
//                     }
//                 );

//                 const translation = response.data.choices[0].message.content.trim();
//                 translationsObj[word] = translation;
//             }

//             setTranslations(translationsObj);
//         } catch (error) {
//             console.error('Error fetching translations from GPT:', error.response ? error.response.data : error.message);
//             setTranslations({
//                 order: 'طلب',
//                 coffee: 'قهوة',
//                 sweet: 'حلا',
//                 price: 'سعر',
//                 thanks: 'شكراً'
//             }); // Default translations if API call fails
//         }
//     };


//     const handleNextStep = () => {
//         if (currentStep < 3) {
//             setCurrentStep(currentStep + 1);
//         } else if (currentWordIndex < currentRoundWords.length - 1) {
//             setCurrentWordIndex(currentWordIndex + 1);
//             setCurrentStep(0);
//         } else {
//             // If the entire round is complete, add points and start a new round
//             setPoints(points + 5);
//             generateNewRound();
//         }
//     };

//     if (currentStep === 0) {
//         return <ImageSelection word={currentRoundWords[currentWordIndex]} onNext={handleNextStep} />;
//     } else if (currentStep === 1) {
//         return <Translation word={currentRoundWords[currentWordIndex]} translations={translations} onNext={handleNextStep} />;
//     } else if (currentStep === 2) {
//         return <SentenceFormation word={currentRoundWords[currentWordIndex]} onNext={handleNextStep} />;
//     } else if (currentStep === 3) {
//         return <CompletionScreen word={currentRoundWords[currentWordIndex]} onNext={handleNextStep} />;
//     } else {
//         return <MatchingPairs words={currentRoundWords} />;
//     }
// };

// export default LearningFlow;

import React, { useState, useEffect } from 'react';
import ImageSelection from './ImageSelection';
import Translation from './Translation';
import SentenceFormation from './SentenceFormation';
import CompletionScreen from './CompletionScreen';
import MatchingPairs from './MatchingPairs';
import axios from 'axios';

const LearningFlow = () => {
    const [currentWordIndex, setCurrentWordIndex] = useState(0);
    const [currentStep, setCurrentStep] = useState(0);
    const [points, setPoints] = useState(0);
    const [rounds, setRounds] = useState([]);
    const [currentRoundWords, setCurrentRoundWords] = useState([]);
    const [translations, setTranslations] = useState({});

    useEffect(() => {
        if (rounds.length === 0) {
            generateNewRound();
        } else {
            setCurrentRoundWords(rounds[rounds.length - 1]);
        }
    }, [rounds]);

    useEffect(() => {
        if (currentRoundWords.length > 0) {
            fetchTranslationsForWords(currentRoundWords);
        }
    }, [currentRoundWords]);

    const saveLearnedWordsToLocalStorage = (newWords) => {
        let learnedWords = JSON.parse(localStorage.getItem('learnedWords')) || [];
        learnedWords = [...learnedWords, ...newWords];
        localStorage.setItem('learnedWords', JSON.stringify(learnedWords));
    };

    const fetchLearnedWordsFromLocalStorage = () => {
        return JSON.parse(localStorage.getItem('learnedWords')) || [];
    };

    const generateNewRound = async () => {
        const learnedWords = [...fetchLearnedWordsFromLocalStorage(), ...rounds.flat()]; // All words learned so far
        const newWords = await fetchNewWordsFromGPT(learnedWords); // Fetch new words from GPT
        setRounds([...rounds, newWords]); // Add the new round of words
        setCurrentRoundWords(newWords); // Update the current round words
        setCurrentWordIndex(0); // Reset to the first word of the new round
        setCurrentStep(0); // Reset to the first step of the learning flow
        saveLearnedWordsToLocalStorage(newWords); // Save new words to local storage
    };

    const fetchNewWordsFromGPT = async (learnedWords) => {
        const apiKey = 'sk-proj-R8ckuOJvBGOO7ZOFsF2kT3BlbkFJ2RtkJrlmX1tXU7OFyBAD';
        const url = 'https://api.openai.com/v1/chat/completions';

        const learnedWordsString = learnedWords.join(', ');
        console.log(learnedWordsString);

        try {
            const response = await axios.post(
                url,
                {
                    model: 'gpt-3.5-turbo',
                    messages: [
                        { role: 'system', content: 'You are a language assistant.' },
                        {
                            role: 'user',
                            content: `I have already learned the following words: ${learnedWordsString}. Please give me five new simple words for learning.`,
                        },
                    ],
                    max_tokens: 50,
                    n: 1,
                    stop: null,
                    temperature: 0.7,
                },
                {
                    headers: {
                        'Authorization': `Bearer ${apiKey}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            const words = response.data.choices[0].message.content.match(/\d+\.\s*(\w+)/g).map(item => item.split('. ')[1]);
            return words;
        } catch (error) {
            console.error('Error fetching words from GPT:', error.response ? error.response.data : error.message);
            return ['apple', 'banana', 'cat', 'dog', 'elephant']; // Default words if API call fails
        }
    };

    const fetchTranslationsForWords = async (words) => {
        const apiKey = 'sk-proj-R8ckuOJvBGOO7ZOFsF2kT3BlbkFJ2RtkJrlmX1tXU7OFyBAD';
        const url = 'https://api.openai.com/v1/chat/completions';

        try {
            const translationsObj = {};

            for (const word of words) {
                const response = await axios.post(
                    url,
                    {
                        model: 'gpt-3.5-turbo',
                        messages: [
                            { role: 'system', content: 'You are a language assistant.' },
                            {
                                role: 'user',
                                content: `Translate the word "${word}" to Arabic. Please provide only the single Arabic word without any additional text, explanations, or punctuation.`,
                            },
                        ],
                        max_tokens: 50,
                        n: 1,
                        stop: null,
                        temperature: 0.7,
                    },
                    {
                        headers: {
                            'Authorization': `Bearer ${apiKey}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );

                const translation = response.data.choices[0].message.content.trim();
                translationsObj[word] = translation;
            }

            setTranslations(translationsObj);
        } catch (error) {
            console.error('Error fetching translations from GPT:', error.response ? error.response.data : error.message);
            setTranslations({
                order: 'طلب',
                coffee: 'قهوة',
                sweet: 'حلا',
                price: 'سعر',
                thanks: 'شكراً'
            }); // Default translations if API call fails
        }
    };

    // const handleNextStep = () => {
    //     if (currentStep < 3) {
    //         setCurrentStep(currentStep + 1);
    //     } else if (currentWordIndex < currentRoundWords.length - 1) {
    //         setCurrentWordIndex(currentWordIndex + 1);
    //         setCurrentStep(0);
    //     } else {
    //         // If the entire round is complete, add points and start a new round
    //         setPoints(points + 5);
    //         generateNewRound();
    //     }
    // };

    const handleNextStep = () => {
        if (currentStep < 3) {
            setCurrentStep(currentStep + 1);
        } else if (currentWordIndex < currentRoundWords.length - 1) {
            setCurrentWordIndex(currentWordIndex + 1);
            setCurrentStep(0);
        } else {
            // If the entire round is complete, add points and navigate to MatchingPairs
            setPoints(points + 5);
            setCurrentStep(4); // Navigate to MatchingPairs component
        }
    };
    
    if (currentStep === 0) {
        return <ImageSelection word={currentRoundWords[currentWordIndex]} onNext={handleNextStep} />;
    } else if (currentStep === 1) {
        return <Translation word={currentRoundWords[currentWordIndex]} translations={translations} onNext={handleNextStep} />;
    } else if (currentStep === 2) {
        return <SentenceFormation word={currentRoundWords[currentWordIndex]} onNext={handleNextStep} />;
    } else if (currentStep === 3) {
        return <CompletionScreen word={currentRoundWords[currentWordIndex]} onNext={handleNextStep} />;
    } else {
        return <MatchingPairs pairs={currentRoundWords.map(word => ({ english: word, arabic: translations[word] }))} />;
        // return <MatchingPairs words={currentRoundWords} />;
    }
};

export default LearningFlow;
